import api from './api';
import * as consts from '../../utils/constants/url';

const enquiryApi = api.injectEndpoints({
  endpoints: build => ({
    createEnquiry: build.mutation({
      query(body = {}) {
        return {
          url: `/guest${consts.API_PROPERTY_VIEWING_ENQUIRIES}`,
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

export const {useCreateEnquiryMutation} = enquiryApi;

export default enquiryApi;
